// src/functions/TrackEmployeeFunctions.js

// ============================================================
// GET PROFILE LOCATION + CALCULATE DISTANCE
// ============================================================

import API_URL from "./config";

export const getProfileLocation = async () => {

    try {

        const token = localStorage.getItem("emptoken");

        const employee = JSON.parse(
            localStorage.getItem("empuser") || "null"
        );

        if (!token) {
            console.log("Employee token not found");
            return null;
        }

        if (!employee) {
            console.log("Employee data not found");
            return null;
        }

        const compid = employee.compid;

        if (!compid) {
            console.log("Company ID not found");
            return null;
        }


        // Employee last location
        const lastLocationData =
            localStorage.getItem("lastLocation");


        if (!lastLocationData) {
            console.log(
                "Last employee location not found"
            );

            return null;
        }


        const lastLocation =
            JSON.parse(lastLocationData);


        const employeeLat =
            Number(lastLocation.latitude);

        const employeeLng =
            Number(lastLocation.longitude);


        // API
        const response = await fetch(
            `${API_URL}/user-profile-location/${compid}`,
            {
                method: "GET",

                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );


        const data = await response.json();


        if (!response.ok) {

            console.log(data.message);

            return null;
        }


        if (data.success) {

            const profileLat =
                Number(data.location.latitude);

            const profileLng =
                Number(data.location.longitude);


            // ============================================
            // DISTANCE CALCULATION
            // ============================================

            const R = 6371;

            const dLat =
                (employeeLat - profileLat)
                * Math.PI / 180;


            const dLng =
                (employeeLng - profileLng)
                * Math.PI / 180;


            const a =
                Math.sin(dLat / 2) *
                Math.sin(dLat / 2) +

                Math.cos(profileLat * Math.PI / 180) *
                Math.cos(employeeLat * Math.PI / 180) *

                Math.sin(dLng / 2) *
                Math.sin(dLng / 2);


            const c =
                2 *
                Math.atan2(
                    Math.sqrt(a),
                    Math.sqrt(1 - a)
                );


            const distanceKm = R * c;

            const distanceMeters =
                distanceKm * 1000;


            return {

                profileLocation: {
                    latitude: profileLat,
                    longitude: profileLng
                },

                employeeLocation: {
                    latitude: employeeLat,
                    longitude: employeeLng
                },

                distanceKm,

                distanceMeters
            };
        }


        return null;


    } catch (error) {

        console.error(
            "Profile Location API Error:",
            error
        );

        return null;
    }
};



// ============================================================
// GET + SAVE CURRENT LOCATION
// ============================================================

export const updateLocation = () => {

    navigator.geolocation.getCurrentPosition(

        (position) => {

            const location = {

                latitude:
                    position.coords.latitude,

                longitude:
                    position.coords.longitude,

                recordedAt:
                    new Date().toISOString()
            };


            localStorage.setItem(
                "lastLocation",
                JSON.stringify(location)
            );
        },


        (error) => {

            console.log(
                "Location error:",
                error
            );
        },


        {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        }
    );
};



// ============================================================
// AUTO CHECKOUT
// ============================================================

export const handlePageHide = (navigate) => {

    const employee = JSON.parse(
        localStorage.getItem("empuser") || "null"
    );


    const lastLocation = JSON.parse(
        localStorage.getItem("lastLocation") || "null"
    );


    if (!employee) {
        return;
    }


    const checkoutDateTime =
        new Date().toISOString();


    const payload = {

        employeeId:
            employee._id,

        companyId:
            employee.compid,

        checkoutTime:
            checkoutDateTime,

        latitude:
            lastLocation?.latitude || null,

        longitude:
            lastLocation?.longitude || null
    };


    fetch(
        `${API_URL}/attendance/auto-checkout`,
        {
            method: "POST",

            keepalive: true,

            headers: {
                "Content-Type": "application/json"
            },

            body: JSON.stringify(payload)
        }
    )
        .catch((error) => {

            console.log(
                "Auto checkout error:",
                error
            );
        });


    // Clear localStorage
    localStorage.clear();


    if (navigate) {
        navigate("/mark-attendance");
    }
};



// ============================================================
// FETCH ATTENDANCE
// ============================================================

export const fetchAttendance = async ({
    empid,
    compid,
    token,
    range,
    fromDate,
    toDate
}) => {

    try {

        let url =
            `${API_URL}/employee-attendance/${empid}/${compid}?range=${range}`;


        if (range === "custom") {

            if (!fromDate || !toDate) {

                alert(
                    "Please select From Date and To Date"
                );

                return [];
            }


            url +=
                `&fromDate=${fromDate}&toDate=${toDate}`;
        }


        const response =
            await fetch(url, {

                method: "GET",

                headers: {

                    Authorization:
                        `Bearer ${token}`,

                    "Content-Type":
                        "application/json"
                }
            });


        const text =
            await response.text();


        if (!response.ok) {

            throw new Error(
                `HTTP Error ${response.status}`
            );
        }


        let result;


        try {

            result =
                JSON.parse(text);

        } catch (error) {

            console.error(
                "Server returned non-JSON response:",
                text
            );

            throw new Error(
                "API is not returning JSON"
            );
        }


        return result.data || [];


    } catch (error) {

        console.error(
            "Attendance Error:",
            error
        );

        return [];
    }
};



// ============================================================
// CHECKOUT
// ============================================================


export const handleCheckOut = async (
    setCheckedOut,
    navigate,
    setLoading
) => {

    try {

        const token =
            localStorage.getItem("emptoken");


        if (!token) {

            alert(
                "Employee token not found. Please login again."
            );

            setLoading(false);

            return;
        }


        navigator.geolocation.getCurrentPosition(

            async (position) => {

                try {

                    const latitude =
                        position.coords.latitude;

                    const longitude =
                        position.coords.longitude;


                    const response =
                        await fetch(
                            `${API_URL}/attendance/check-out`,
                            {
                                method: "POST",

                                headers: {

                                    Authorization:
                                        `Bearer ${token}`,

                                    "Content-Type":
                                        "application/json"

                                },

                                body: JSON.stringify({
                                    latitude,
                                    longitude
                                })

                            }
                        );


                    const data =
                        await response.json();


                    if (!response.ok) {

                        alert(
                            data.message ||
                            "Unable to checkout"
                        );

                        setLoading(false);

                        return;
                    }


                    if (data.success) {

                        setCheckedOut(true);


                        // =====================================
                        // WORKING TIME IN SECONDS
                        // =====================================

                        const totalSeconds =
                            Number(
                                data.workingSeconds ??
                                data.attendance?.workingMinutes ??
                                0
                            );


                        // =====================================
                        // CONVERT SECONDS TO HH:MM:SS
                        // =====================================

                        const hours =
                            Math.floor(
                                totalSeconds / 3600
                            );


                        const minutes =
                            Math.floor(
                                (totalSeconds % 3600) / 60
                            );


                        const seconds =
                            totalSeconds % 60;


                        const formattedTime =
                            `${String(hours).padStart(2, "0")}:` +
                            `${String(minutes).padStart(2, "0")}:` +
                            `${String(seconds).padStart(2, "0")}`;


                        // =====================================
                        // SHOW EXACT WORKING TIME
                        // =====================================

                        alert(
                            `Check-out successful.\nWorking time: ${formattedTime}`
                        );


                        localStorage.clear();

                        setLoading(false);

                        navigate("/mark-attendance");

                    }


                } catch (error) {

                    console.error(
                        "CHECKOUT ERROR:",
                        error
                    );

                    alert(
                        "Unable to checkout"
                    );

                    setLoading(false);

                }

            },


            (error) => {

                console.error(
                    "GPS ERROR:",
                    error
                );


                if (error.code === 1) {

                    alert(
                        "Location permission denied. Please allow location access to checkout."
                    );

                } else if (error.code === 2) {

                    alert(
                        "Unable to get your current location."
                    );

                } else if (error.code === 3) {

                    alert(
                        "Location request timed out. Please try again."
                    );

                } else {

                    alert(
                        "Unable to get your location."
                    );

                }


                setLoading(false);

            },


            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }

        );


    } catch (error) {

        console.error(
            "CHECKOUT ERROR:",
            error
        );

        alert(
            "Unable to checkout"
        );

        setLoading(false);

    }

};